// src/packages/chubb/pa/chubb_pa_series_a_2025/index.js
import ChubbPASeriesACard from "./ChubbPASeriesACard";
import ChubbPASeriesADetails from "./ChubbPASeriesADetails";
import "./chubb_pa_series_a.css";

/** Chubb — PA Series A (Plans 1–8 + Kid), Effective 2025 */
export default {
  id: "chubb_pa_series_a_2025",
  company: "ชับบ์ (Chubb)",                // ⚠️ ให้ตรงกับ COMPANY_INFO ของโปรเจ็กต์คุณ
  productLine: "non-motor",
  categories: ["personal accident", "PA", "health"],
  nameTH: "Chubb PA Series A — แผน 1–8 + Kid",
  description: "ประกันอุบัติเหตุส่วนบุคคล คุ้มครองชีวิต/ทุพพลภาพ/ค่ารักษา พร้อมแพ็กครอบครัว",
  accent: "#00a651",
  expiresAt: "9999-12-31",
  card: ChubbPASeriesACard,
  detail: ChubbPASeriesADetails,
  active: true,
};
